module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audit_edit_pf pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("业务联系人信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "basicForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.basicForm,
      "rules": _vm.rules,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:",
      "prop": "contactName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人姓名",
      "maxlength": 5
    },
    model: {
      value: (_vm.basicForm.contactName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactName", $$v)
      },
      expression: "basicForm.contactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:",
      "prop": "contactMobile"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人手机号"
    },
    model: {
      value: (_vm.basicForm.contactMobile),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactMobile", $$v)
      },
      expression: "basicForm.contactMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人座机"
    },
    model: {
      value: (_vm.basicForm.contactLandline),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactLandline", $$v)
      },
      expression: "basicForm.contactLandline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:",
      "prop": "contactEmail",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人邮箱"
    },
    model: {
      value: (_vm.basicForm.contactEmail),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactEmail", $$v)
      },
      expression: "basicForm.contactEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:",
      "prop": "contactQQ"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人QQ"
    },
    model: {
      value: (_vm.basicForm.contactQQ),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactQQ", $$v)
      },
      expression: "basicForm.contactQQ"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "contactPosition"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "number": "",
      "placeholder": "请输入联系人职务"
    },
    model: {
      value: (_vm.basicForm.contactPosition),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contactPosition", _vm._n($$v))
      },
      expression: "basicForm.contactPosition"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("合同联系人信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:",
      "prop": "contractContactName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人姓名",
      "maxlength": 5
    },
    model: {
      value: (_vm.basicForm.contractContactName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactName", $$v)
      },
      expression: "basicForm.contractContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:",
      "prop": "contractContactMobile"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人手机号"
    },
    model: {
      value: (_vm.basicForm.contractContactMobile),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactMobile", $$v)
      },
      expression: "basicForm.contractContactMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人座机"
    },
    model: {
      value: (_vm.basicForm.contractContactLandline),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactLandline", $$v)
      },
      expression: "basicForm.contractContactLandline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:",
      "prop": "contractContactEmail",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人邮箱"
    },
    model: {
      value: (_vm.basicForm.contractContactEmail),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactEmail", $$v)
      },
      expression: "basicForm.contractContactEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:",
      "prop": "contractContactQQ"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人QQ"
    },
    model: {
      value: (_vm.basicForm.contractContactQQ),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactQQ", $$v)
      },
      expression: "basicForm.contractContactQQ"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "contractContactPosition"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "number": "",
      "placeholder": "请输入联系人职务"
    },
    model: {
      value: (_vm.basicForm.contractContactPosition),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "contractContactPosition", _vm._n($$v))
      },
      expression: "basicForm.contractContactPosition"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("客服联系人信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "联系人姓名:",
      "prop": "customServiceContactName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人姓名",
      "maxlength": 5
    },
    model: {
      value: (_vm.basicForm.customServiceContactName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customServiceContactName", $$v)
      },
      expression: "basicForm.customServiceContactName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人手机号:",
      "prop": "customServiceContactMobile"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人手机号"
    },
    model: {
      value: (_vm.basicForm.customServiceContactMobile),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customServiceContactMobile", $$v)
      },
      expression: "basicForm.customServiceContactMobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人座机:"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人座机"
    },
    model: {
      value: (_vm.basicForm.customServiceContactLandline),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customServiceContactLandline", $$v)
      },
      expression: "basicForm.customServiceContactLandline"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人邮箱:",
      "prop": "customServiceContactEmail",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'blur'
        }
      ]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人邮箱"
    },
    model: {
      value: (_vm.basicForm.customServiceContactEmail),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customServiceContactEmail", $$v)
      },
      expression: "basicForm.customServiceContactEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人QQ:",
      "prop": "customServiceContactQQ"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入联系人QQ"
    },
    model: {
      value: (_vm.basicForm.customServiceContactQQ),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customServiceContactQQ", $$v)
      },
      expression: "basicForm.customServiceContactQQ"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职务:",
      "prop": "customServiceContactPosition"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "number": "",
      "placeholder": "请输入联系人职务"
    },
    model: {
      value: (_vm.basicForm.customServiceContactPosition),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "customServiceContactPosition", _vm._n($$v))
      },
      expression: "basicForm.customServiceContactPosition"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-button', {
    staticClass: "mr30",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnPage
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "mr30",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmSave('basicForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a59343d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/manage/contactInfo.vue
// module id = 524
// module chunks = 0